import { apiUrl, apiUrlV2 } from "../constants/apiUrl"

const initialState = {
  bankAccounts: [],
  isSendingPlaidLink: false,
}

const createBankAccountSlice = (set, get) => ({
  ...initialState,
  fetchBankAccounts: () => fetch(
    `${apiUrl}/bank-accounts`,
    { headers: get().requestHeaders }
  )
    .then(response => response.json())
    .then(data => set((state) => ({ bankAccounts: data.data }))),
  createBankAccount: (body) => fetch(
    `${apiUrl}/bank-accounts`, {
      method: 'POST',
      headers: get().requestHeaders,
      body: JSON.stringify(body)
    }
  ),
  removeBankAccount: (id) => fetch(
    `${apiUrlV2}/bank-accounts/${id}/deactivate`, {
      method: 'PUT',
      headers: get().requestHeaders
    }
  ),
  makeDefaultAccount: (id) => fetch(
    `${apiUrl}/bank-accounts/${id}/make-default`, {
      method: 'PUT',
      headers: get().requestHeaders
    }
  ),
  achAuthorizeBankAccounts: (body) => fetch(
    `${apiUrlV2}/bank-accounts/ach-authorization`, {
      method: 'PUT',
      headers: get().requestHeaders,
      body: JSON.stringify(body)
    }
  ),
  fetchBankAccountsAsAm: (dealerId) => fetch(
    `${apiUrlV2}/dealers/${dealerId}/bank_accounts`,
    { headers: get().requestHeaders }
  )
    .then(response => response.json())
    .then(data => set((state) => ({ bankAccounts: data.data }))),
  sendPlaidLink: async (dealerId = null) => {
    set(() => ({ isSendingPlaidLink: true }))
    try {
      const response = await fetch(`${apiUrlV2}/plaid_links`, {
        method: 'POST',
        headers: get().requestHeaders,
        body: JSON.stringify(dealerId ? { dealer_id: dealerId } : {}),
      })
      const data = await response.json()

      if (response.status === 200) {
        get().setSuccessMessage(data.data.message)
        return true
      }

      get().setErrMessage(data?.errors?.message || 'Unable to send the Plaid link.')
      return false
    } catch (err) {
      get().logError('There was an error sending the Plaid link.', err)
      return false
    } finally {
      set(() => ({ isSendingPlaidLink: false }))
    }
  },
  resetBankAccountSlice: () => set(initialState)
})

export default createBankAccountSlice